/**
 * Shared quarter date utilities used by both API and frontend.
 * All dates use UTC to avoid timezone-related boundary shifts.
 */

export const getCurrentQuarter = () => {
  const now = new Date();
  return {
    year: now.getUTCFullYear(),
    quarter: Math.floor(now.getUTCMonth() / 3) + 1,
  };
};

export const getPreviousQuarter = (year: number, quarter: number) =>
  quarter === 1
    ? { year: year - 1, quarter: 4 }
    : { year, quarter: quarter - 1 };

export const getQuarterBounds = (year: number, quarter: number) => {
  const startMonth = (quarter - 1) * 3;
  const start = new Date(Date.UTC(year, startMonth, 1));
  const end = new Date(Date.UTC(year, startMonth + 3, 0, 23, 59, 59, 999));
  return { start, end };
};
